module.exports = true;



//////////////////
// WEBPACK FOOTER
// /home/g0/live-stream/web-client/node_modules/core-js/library/modules/_library.js
// module id = fx2r
// module chunks = 5 6 7 8